import React from 'react';
import Button from '@material-ui/core/Button';


const ButtonCustom = (props) => {

  return (
    <Button
    onClick={props.onClick}
    type="submit"
    fullWidth
    variant="contained">
    {props.label}
 </Button>
  );
};

export { ButtonCustom }